import { render, staticRenderFns } from "./GeneralMetrics.vue?vue&type=template&id=41dcdae8&scoped=true"
import script from "./GeneralMetrics.vue?vue&type=script&lang=js"
export * from "./GeneralMetrics.vue?vue&type=script&lang=js"
import style0 from "./GeneralMetrics.vue?vue&type=style&index=0&id=41dcdae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dcdae8",
  null
  
)

export default component.exports